import {apolloClient} from "../../plugins/apollo-client";
import SIGN_IN from '../../graphql/auth/signIn.gql'
import GET_SELF from '../../graphql/auth/getSelf.gql'
import FORGOT_PASSWORD from '../../graphql/auth/forgotPassword.gql'

const signIn = (email, password, gRecaptcha) =>
  apolloClient.mutate({
    mutation: SIGN_IN,
    variables: {
      email,
      password,
      gRecaptcha
    }
  }).then(({data}) => data);


const forgotPassword = (email, gRecaptcha) =>
  apolloClient.mutate({
    mutation: FORGOT_PASSWORD,
    variables: {
      email,
      gRecaptcha
    }
  }).then(({data}) => data);

const getSelf = () =>
  apolloClient.query({
    query: GET_SELF
  }).then(({data}) => data.user)

export {
  signIn,
  forgotPassword,
  getSelf
}
